import { ICartItem } from '../../../../container/cart/ICart';
import { safeGet } from '../../../../utils/objectUtils';
import { IAttribute, ILineItem } from '../cartInterface';
import {
  Attributes
} from '../constants';
import { ProductTypes } from './../constants';
import { formatPrice } from './../reshapeCartData';

export const reshapeSavingsPlanData = (item: ILineItem) => {
  const savingsPlan = {} as ICartItem;
  savingsPlan.id = item.id;
  savingsPlan.type = ProductTypes.SAVINGS_PLAN;
  savingsPlan.sku = item.variant?.sku;
  savingsPlan.isPriceValid = item.isPriceValid;
  const variantAttributes = safeGet(item, 'variant.attributes', []);
  if (variantAttributes.length) {
    savingsPlan.isAvailable = variantAttributes.find((attr: any) => attr.name === Attributes.IS_AVAILABLE)?.value || '';
    const planType: IAttribute = variantAttributes.find((attr: any) => attr?.name === Attributes.ITEM_REFERENCE);
    savingsPlan.planType = planType.value;
  }
  savingsPlan.parentLineItemId = safeGet(item, 'custom.fields.parentLineItemId', '');
  if (safeGet(item, 'totalPrice.centAmount', '')) {
    savingsPlan.price = formatPrice(safeGet(item, 'totalPrice.centAmount', '') / 100);
  }
  return savingsPlan;
}